// Sets version used by TrackingJS component.
// Note: Be sure the @vp/react-tracking version in package.json supports the version here.
export const TRACKING_LIB_VERSION = '9';

// PayPal Message offer types and corresponding message variant
export const PAYPAL_OFFERTYPE_BELOW_30 = 'GPLNQ';
export const PAYPAL_OFFERTYPE_BETWEEN_30_AND_200 = 'GPLQ';
export const PAYPAL_OFFERTYPE_ABOVE_200 = 'LT_MQGZ';
export const PAYPAL_MESSAGE_VARIANT_BELOW_30 = 'Amount below $30';
export const PAYPAL_MESSAGE_VARIANT_BETWEEN_30_AND_200 =
  'Amount between $30 and $200';
export const PAYPAL_MESSAGE_VARIANT_ABOVE_200 = 'Amount more than $200';
